import { useTranslation } from "react-i18next"
import { Copy } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { useToast } from "@/hooks/useToast"

type IdentifierValueProps = {
  label: string
  value: string
  testId: string
}

export const IdentifierValue = ({ label, value, testId }: IdentifierValueProps) => {
  const { t } = useTranslation()
  const { toast } = useToast()

  const handleCopy = () => {
    navigator.clipboard.writeText(value)
    toast({ description: t("admin.advanced.identifierValue.copied") })
  }

  return (
    <div className="flex items-center justify-between gap-2" data-testid={testId}>
      <div className="flex min-w-0 flex-col">
        <span className="text-on-surface-subdued text-xs">{label}</span>
        <code className="text-on-surface text-sm break-all" data-testid={`${testId}-value`}>
          {value}
        </code>
      </div>
      <Button
        variant="tertiary"
        className="p-2"
        aria-label={t("admin.advanced.identifierValue.copy")}
        onClick={handleCopy}
        data-testid={`${testId}-copy-button`}>
        <Copy className="size-4" />
      </Button>
    </div>
  )
}
